import { useState } from 'react';
import { Alert, Placeholder, Table } from 'react-bootstrap';
import useSWRImmutable from 'swr/immutable';
import { Product } from '../types/Product';
import { RSCatalogProductModal } from './RSCatalogProductModal';
import { RSCatalogProductTable } from './RSCatalogProductTable';

type Props = {
  satellite: string;
  target: string | null;
};

const fetcher = async (url: string) => {
  const response = await fetch(url);
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error(`${response.status} ${response.statusText}`);
  }
};

export const RSCatalogProductsContainer = ({ satellite, target }: Props) => {
  const { data, error } = useSWRImmutable<{ products: Product[] }>(
    process.env.PUBLIC_URL + `/api/satellites/${satellite.replace('/', '_')}.json`,
    fetcher
  );
  const [modalProductIndex, setModalProductIndex] = useState<number | null>(null);

  if (error) {
    return (
      <Alert variant="danger">
        <b>エラーが発生しました</b> {`${error}`}
      </Alert>
    );
  }

  if (!data?.products) {
    return (
      <Table>
        <thead>
          <tr>
            <th>観測対象</th>
            <th>プロダクト</th>
            <th>センサ</th>
            <th>分解能</th>
            <th>提供機関</th>
            <th>料金</th>
          </tr>
        </thead>
        <tbody>
          <Placeholder as="tr" animation="glow">
            {[...Array(6)].map((_, i) => (
              <td key={i}>
                <Placeholder className="w-75" />
              </td>
            ))}
          </Placeholder>
        </tbody>
      </Table>
    );
  }

  const filteredProducts = target ? data.products.filter((p) => p.target === target) : data.products;

  return (
    <>
      {filteredProducts.length > 0 ? (
        <RSCatalogProductTable products={filteredProducts} onRowClick={setModalProductIndex} />
      ) : (
        <Alert variant="primary">衛星を選択してください。</Alert>
      )}
      {modalProductIndex !== null ? (
        <RSCatalogProductModal
          product={filteredProducts[modalProductIndex]}
          onHide={() => setModalProductIndex(null)}
          onPreviousButtonClick={() => setModalProductIndex(modalProductIndex > 0 ? modalProductIndex - 1 : null)}
          onNextButtonClick={() =>
            setModalProductIndex(modalProductIndex < filteredProducts.length - 1 ? modalProductIndex + 1 : null)
          }
        />
      ) : null}
    </>
  );
};
